import api from './api'

export type CheckpointType = 'QR' | 'NFC' | 'GEO'

export interface Checkpoint {
    id: number
    name: string
    code?: string
    type: CheckpointType
    radiusMeters: number
    active: boolean
}
export interface PatrolRoute { id: number; name: string; active: boolean }
export interface PatrolTour { id: number; routeId: number; status: string }
export interface TourCompliance { totalCheckpoints: number; verifiedCheckpoints: number; complete: boolean }
export interface DailyActivityReport { id: number; content: string; shiftDate: string; photoUrl?: string }

export const patrolService = {
    listCheckpoints: async (): Promise<Checkpoint[]> =>
        (await api.get<Checkpoint[]>('/api/v1/patrol/checkpoints')).data,
    createCheckpoint: async (req: { name: string; code?: string; type: CheckpointType; lat?: number; lon?: number; radiusMeters?: number }): Promise<Checkpoint> =>
        (await api.post<Checkpoint>('/api/v1/patrol/checkpoints', req)).data,
    createRoute: async (req: { name: string; checkpointIds: number[] }): Promise<PatrolRoute> =>
        (await api.post<PatrolRoute>('/api/v1/patrol/routes', req)).data,
    startTour: async (routeId: number): Promise<PatrolTour> =>
        (await api.post<PatrolTour>(`/api/v1/patrol/routes/${routeId}/tours`)).data,
    scan: async (tourId: number, req: { checkpointId: number; scannedCode?: string; lat?: number; lon?: number; photoUrl?: string }) =>
        (await api.post(`/api/v1/patrol/tours/${tourId}/scan`, req)).data,
    compliance: async (tourId: number): Promise<TourCompliance> =>
        (await api.get<TourCompliance>(`/api/v1/patrol/tours/${tourId}/compliance`)).data,
    submitDar: async (req: { content: string; lat?: number; lon?: number; photoUrl?: string }): Promise<DailyActivityReport> =>
        (await api.post<DailyActivityReport>('/api/v1/patrol/dar', req)).data,
    myDars: async (): Promise<DailyActivityReport[]> =>
        (await api.get<DailyActivityReport[]>('/api/v1/patrol/dar/me')).data,
}
